<a class="skip-link" href="#main-content">Skip to main content</a>

<app-header (menuClick)="drawerOpened.update(opened => !opened)" />

<mat-sidenav-container class="shell-container">
  <mat-sidenav
    class="shell-sidebar"
    [mode]="isMobile() ? 'over' : 'side'"
    [opened]="drawerOpened()"
    [fixedInViewport]="isMobile()"
    [autoFocus]="false"
    (openedChange)="drawerOpened.set($event)"
  >
    <app-sidebar (navigate)="closeDrawerOnMobile()" />
  </mat-sidenav>

  <mat-sidenav-content class="shell-content">
    <main id="main-content" class="page-frame" tabindex="-1">
      <router-outlet />
    </main>
  </mat-sidenav-content>
</mat-sidenav-container>
